import { DropdownData } from '@zayan-erp/shared';
import { createReducer, on } from '@ngrx/store';
import * as HomeBuildingActions from './home-building.actions';

export interface HomeBuildingState {
  projects: DropdownData[];
  lots: DropdownData[];
  projectLots: { [projectId: string]: DropdownData[] };
  projectId: string | null;
  cities: DropdownData[];
  productList: DropdownData[];
  productListId: string | null;
  categoryListByProductListId: { [productListId: string]: DropdownData[] };
  categoryList: DropdownData[];
  subcategories: { [categoryListId: string]: DropdownData[] };
  categoryListId: string | null;
  uofms: DropdownData[];
  locations: DropdownData[];
  countries: DropdownData[];
  citiesByCountryId: DropdownData[];
  templateVariablesTypes: DropdownData[];
}

export const initialHomeBuildingState: HomeBuildingState = {
  projects: [],
  lots: [],
  projectLots: {},
  projectId: null,
  cities: [],
  productList: [],
  productListId: null,
  categoryList: [],
  categoryListByProductListId: {},
  subcategories: {},
  categoryListId: null,
  uofms: [],
  locations: [],
  countries: [],
  citiesByCountryId: [],
  templateVariablesTypes: []
};

export const homeBuildingReducer = createReducer(
  initialHomeBuildingState,
  on(HomeBuildingActions.loadProjectsSuccess, (state, { projects }) => ({
    ...state,
    projects
  })),

  on(HomeBuildingActions.loadLotsSuccess, (state, { lots }) => ({
    ...state,
    lots: lots
  })),

  on(HomeBuildingActions.loadProjectLotsSuccess, (state, { projectLots }) => ({
    ...state,
    projectLots: { ...state.projectLots, ...projectLots }
  })),

  on(HomeBuildingActions.selectedProject, (state, { projectId }) => ({
    ...state,
    projectId
  })),

  on(HomeBuildingActions.loadCitiesSuccess, (state, { cities }) => ({
    ...state,
    cities
  })),

  on(HomeBuildingActions.loadProductListSuccess, (state, { productList }) => ({
    ...state,
    productList
  })),

  on(HomeBuildingActions.loadCategoryListByProductListIdSuccess, (state, { categoryListByProductListId }) => ({
    ...state,
    categoryListByProductListId: { ...state.categoryListByProductListId, ...categoryListByProductListId }
  })),

  on(HomeBuildingActions.loadCategoryListSuccess, (state, { categoryList }) => ({
    ...state,
    categoryList
  })),

  on(HomeBuildingActions.loadSubcategoriesSuccess, (state, { subcategories }) => ({
    ...state,
    subcategories: { ...state.subcategories, ...subcategories }
  })),

  on(HomeBuildingActions.loadUofmsSuccess, (state, { uofms }) => ({
    ...state,
    uofms
  })),

  on(HomeBuildingActions.loadProjectLocationsSuccess, (state, { locations }) => ({
    ...state,
    locations: locations
  })),
  on(HomeBuildingActions.loadCountriesSuccess, (state, { countries }) => ({
    ...state,
    countries
  })),
  on(HomeBuildingActions.loadCitiesByCountryIdSuccess, (state, { cities }) => ({
    ...state,
    citiesByCountryId: cities
  })),
  on(HomeBuildingActions.setTemplateTypes, (state, { templateTypes }) => ({
    ...state,
    templateVariablesTypes: templateTypes
  }))
);
